import that from '../utilities/translationHelper'

const searchTypes = {
	ITEM: {
		type: 'ITEM',
		name: that.context.translate('Item')
	},
	USER: {
		type: 'USER',
		name: that.context.translate('User')
	},
	KIT: {
		type: 'KIT',
		name: that.context.translate('Kit')
	},
	EVERYTHING: {
		type: 'EVERYTHING',
		name: that.context.translate('Everything')
	}
}

export const allSearchTypes = Object.keys(searchTypes).map(type => searchTypes[type].type)

export default searchTypes



// WEBPACK FOOTER //
// ./src/enums/searchTypes.js